import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useRouteMatchCompat from '../../../router/useRouteMatchCompat';
import { Container, Row, Col } from 'react-bootstrap';
import api from 'services/api';
import { useEffectThrottled } from 'hooks';
import TravelInformationCarousel from 'v3/components/ModalInformation';
import Sidebar from 'v3/components/Menu/Sidebar';
import { useSidebar } from 'v3/components/Menu/Sidebar/SidebarContext';
import routes from '../../../config/MenuNavConstants';
import Text from '../../components/Text';
import Menu from '../../components/Menu';
import * as Styled from './styles';
import './styles.css';

export default function ApplicationLayout({
  hideMenu = false,
  menuOnly,
  RightComponent,
  onlyCenterComponent = false,
  contentFluid,
  children,
  isOld = false,
  title,
  fontSize,
  headerMarginTop = -130,
  maxWidth,
  // Título no centro da barra do menu, sem breadcrumb, e o conteúdo logo abaixo, para telas que precisam de altura útil.
  compactHeader = false,
}) {
  const location = useLocation();
  const match = useRouteMatchCompat(location.pathname);
  const { isMenuOpen } = useSidebar();

  const instance = useSelector(store => store.instance);

  const breadcrumbs = routes
    .filter(({ path }) => match.path.includes(path))
    .map(({ path, ...rest }) => ({
      path: Object.keys(match.params).length
        ? Object.keys(match.params).reduce(
          (acc, param) => acc.replace(`:${param}`, match.params[param]),
          path
        )
        : path,
      ...rest,
    }))
    .sort((a, b) => a.path.length - b.path.length);

  async function handleLogs() {
    try {
      const data = {
        name: typeof title !== 'object' ? title : 'dashboard',
        path: location.pathname,
        description: 'navigation',
        instance: instance || null,
      };

      await api.post('v3/user/logs', data);
    } catch (error) {
      return [];
    }
  }

  useEffectThrottled(
    () => {
      handleLogs();
    },
    [location.pathname, instance],
    1500
  );

  const { length, [length - 1]: last, 1: second } = breadcrumbs;

  const contentStyle = {
    maxWidth: maxWidth || '1245px',
    margin: '0 auto',
    width: '100%',
  };
  return (
    <div>
      <Sidebar />
      <div>
        {!hideMenu && (
          <Menu path={second} title={compactHeader ? title || last?.title : undefined} />
        )}
        <Styled.Header $isOld={isOld} $compact={compactHeader} className="header-main">
          <Styled.HeaderContentWrapper $isOpen={isMenuOpen}>
            {compactHeader ? (
              // Abaixo de 1200px o menu não tem espaço para o título, que fica aqui.
              <Text type="subtitle" color="white" className="text-title d-block d-xl-none px-3 pt-2">
                {title || last?.title || ''}
              </Text>
            ) : !menuOnly && !onlyCenterComponent ? (
              <Container id="header-container">
                <Row>
                  <Col
                    lg={6}
                    md={6}
                    xs={4}
                    className="py-3 left-component"
                  >
                    <Text type="subtitle" color="white" className="text-title">
                      {location.pathname === '/' ? 'Início' : title || last?.title || ''}
                    </Text>
                    {location.pathname !== '/' && (
                      <Styled.Breadcrumb listProps={{ className: 'p-0' }}>
                        {breadcrumbs.map(bread => (
                          <Styled.BreadcrumbItem
                            key={bread.path}
                            linkAs={Link}
                            linkProps={{ to: bread.path }}
                          >
                            <Text type="label" color="white">
                              {bread.title}
                            </Text>
                          </Styled.BreadcrumbItem>
                        ))}
                      </Styled.Breadcrumb>
                    )}
                  </Col>

                  <Col
                    lg={6}
                    md={6}
                    xs={8}
                    className="py-3 right-component"
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: '10px',
                        width: '100%',
                        height: '100%',
                      }}
                    >
                      {RightComponent}
                    </div>
                  </Col>
                </Row>
              </Container>
            ) : !menuOnly && onlyCenterComponent ? (
              <Row md={12} xs={12} style={{ marginRight: '0' }}>
                <Col md={5} xs={5}>
                  <TravelInformationCarousel />
                </Col>
                <Col md={7} xs={7}>
                  <Text
                    type="subtitle"
                    color="white"
                    className="text-title"
                    fontSize={fontSize}
                  >
                    {location.pathname === '/' ? 'Início' : title || last?.title || ''}
                  </Text>
                  <div>
                    {location.pathname !== '/' && (
                      <Styled.Breadcrumb listProps={{ className: 'p-0' }}>
                        {breadcrumbs.map(bread => (
                          <Styled.BreadcrumbItem
                            key={bread.path}
                            linkAs={Link}
                            linkProps={{ to: bread.path }}
                          >
                            <Text type="label" color="white">
                              {bread.title}
                            </Text>
                          </Styled.BreadcrumbItem>
                        ))}
                      </Styled.Breadcrumb>
                    )}
                  </div>
                </Col>
              </Row>
            ) : null}
          </Styled.HeaderContentWrapper>
        </Styled.Header>
        <Styled.ContentContainer $isOpen={isMenuOpen}>
          <Styled.Main
            $isOld={isOld}
            fluid={contentFluid}
            $marginTop={compactHeader ? -Styled.COMPACT_HEADER_OVERLAP : headerMarginTop}
            $maxWidth={maxWidth}
          >
            {children}
          </Styled.Main>
        </Styled.ContentContainer>
      </div>
    </div>
  );
}
